// @flow
import { compose, withProps, withHandlers } from 'recompose'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import withTranslations from '../../../core/withTranslations'
import withHandleCancel from '../withHandleCancel'
import CharityInfoForm from '../../../ui/forms/charity-info-form'
import { validateRequired } from '../../validations/validations'
import {
  openContactFormModal,
  closeContactFormModal,
  openDeleteContactModal
} from './actions'
import { isContactFormModalOpen } from './selectors'

const translations = withTranslations({
  titleText: 'charity.infoForm.title',
  charityNameText: 'charity.infoForm.charityName',
  shortDescriptionText: 'charity.infoForm.shortDescription',
  shortDescriptionHelperText: 'charity.infoForm.shortDescriptionHelper',
  descriptionText: 'charity.infoForm.description',
  descriptionHelperText: 'charity.infoForm.descriptionHelper',
  coverImageText: 'charity.infoForm.coverImage',
  coverImageHelperText: 'charity.infoForm.coverImageHelper',
  socialMediaText: 'charity.infoForm.socialMedia',
  facebookLinkText: 'charity.infoForm.facebookLink',
  twitterLinkText: 'charity.infoForm.twitterLink',
  instagramLinkText: 'charity.infoForm.instagramLink',
  googlePlusLinkText: 'charity.infoForm.googlePlusLink',
  contactText: 'charity.infoForm.contact',
  yourWebsiteText: 'charity.infoForm.yourWebsite',
  contactBlockText: 'charity.infoForm.contactBlock',
  contactBlockHelperText: 'charity.infoForm.contactBlockHelper',
  addContactDataText: 'charity.infoForm.addContactData',
  optionalText: 'common:optional',
  errorNotificationText: 'forms.validation.errorNotification',
  cancelText: 'common:cancel',
  saveText: 'common:save'
})

const withInitialValuesAndCharityContacts = withProps(props => ({
  initialValues: {
    name: props.charity.name,
    shortDescription: props.charity.shortDescription,
    description: props.charity.description,
    photo: props.charity.photo,
    facebook: props.charity.facebook,
    twitter: props.charity.twitter,
    instagram: props.charity.instagram,
    googlePlus: props.charity.googlePlus,
    website: props.charity.website
  },
  charityContacts: props.charity.contacts
}))

const withReduxForm = reduxForm({
  form: 'editCharityInfo',
  validate: values => ({
    name: validateRequired(values.name),
    shortDescription: validateRequired(values.shortDescription),
    description: validateRequired(values.description)
  }),
  onSubmit: (values, dispatch, props) => {
    // remove fields used only for redux-form
    delete values.photo
    return props.onSave(props.charityId, values).then(props.onGoToCharityInfo())
  }
})

const mapStateToProps = state => ({
  showContactForm: Boolean(isContactFormModalOpen(state))
})
const mapDispatchToProps = {
  onOpenContactFormModal: openContactFormModal,
  onCloseContactFormModal: closeContactFormModal,
  onOpenDeleteContactModal: openDeleteContactModal
}
export const withContactActionsAndSelectors = connect(
  mapStateToProps,
  mapDispatchToProps
)

export const withModalHandlers = withHandlers({
  onAddContact: props => e => {
    e.preventDefault()
    props.onOpenContactFormModal('new contact')
  }
})

export const EditCharityInfoFormEnhancer = compose(
  translations,
  withInitialValuesAndCharityContacts,
  withReduxForm,
  withHandleCancel,
  withContactActionsAndSelectors,
  withModalHandlers
)

export default EditCharityInfoFormEnhancer(CharityInfoForm)



// WEBPACK FOOTER //
// ./src/services/mycharity/charity/EditCharityInfoForm.js